module.exports = __webpack_public_path__ + "img/search-icon.d6b659fa.svg";